import { render, staticRenderFns } from "./taoh.vue?vue&type=template&id=15651b54&scoped=true&"
import script from "./taoh.vue?vue&type=script&lang=js&"
export * from "./taoh.vue?vue&type=script&lang=js&"
import style0 from "./taoh.vue?vue&type=style&index=0&id=15651b54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15651b54",
  null
  
)

export default component.exports